import type { ChecklistItem } from "../types/services"

export const recruitmentChecklist: ChecklistItem[] = [
  { id: "job-posting", name: "Job Posting & Advertisement", selected: false },
  { id: "candidate-sourcing", name: "Candidate Sourcing & Screening", selected: false },
  { id: "resume-screening", name: "Resume Screening & Filtering", selected: false },
  { id: "initial-interviews", name: "Initial Phone/Video Interviews", selected: false },
  { id: "technical-assessment", name: "Technical Skills Assessment", selected: false },
  { id: "background-checks", name: "Background & Reference Checks", selected: false },
  { id: "final-interviews", name: "Final Interview Coordination", selected: false },
  { id: "offer-negotiation", name: "Offer Negotiation & Management", selected: false },
  { id: "onboarding-support", name: "Onboarding Support", selected: false },
  { id: "candidate-database", name: "Candidate Database Management", selected: false },
  { id: "recruitment-analytics", name: "Recruitment Analytics & Reporting", selected: false },
  { id: "others-recruitment", name: "Others (Please specify)", selected: false },
]
